<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <button type="button" class="close" (click)="cancelEvent.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="payoutForm">
      <div class="page__form-wrap">
        <div class="d-flex justify-content-end">
          <label for="payout-mode" class="col-sm-8">{{ 'partner_payout_mode' | translate }}</label>
          <div class="col-sm-8">
            <div id="payout-mode" class="form-check-inline d-flex align-items-center">
              <label class="radio-custom">
                <input type="radio" id="payout-mode-get" name="paymentType" formControlName="paymentType" value="bonifico" />
                <span class="radio-custom__radio"></span>
                <span class="radio-custom__label" translate>shop_payment_bb</span>
              </label>
              <label class="radio-custom">
                <input type="radio" id="payout-mode-post" name="paymentType" formControlName="paymentType" value="paypal" />
                <span class="radio-custom__radio"></span>
                <span class="radio-custom__label" translate>partner_payout_mode_paypal</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- Bank Account Details -->
      <div *ngIf="getChosenPaymentMethod() === 'bonifico'">
        <h5 class="my-5" translate>{{ 'partner_payout_form_bank' }}</h5>
        <div class="page__form-wrap">
          <div class="form-group row">
            <label class="col-sm-4" translate>{{ 'partner_payout_form_bank_name_placeholder' }}</label>
            <div class="col-sm-8">
              <input
                type="text"
                name="name"
                formControlName="name"
                class="form-control"
                placeholder="{{ 'partner_payout_form_bank_name_placeholder' | translate }}"
              />
            </div>
          </div>
          <div class="form-group row" formGroupName="jsonPaymentDetails">
            <label class="col-sm-4" translate>{{ 'partner_payout_form_bank_iban_placeholder' }}</label>
            <div class="col-sm-8">
              <ng-container>
                <input
                  type="text"
                  name="iban"
                  formControlName="iban"
                  class="form-control"
                  placeholder="{{ 'partner_payout_form_bank_iban_placeholder' | translate }}"
                  wsbAppControlValidator
                  [fc]="payoutForm.get('jsonPaymentDetails.iban')"
                />
                <wsb-validation-error-msg [fc]="payoutForm.get('jsonPaymentDetails.iban')"></wsb-validation-error-msg>
              </ng-container>
            </div>
          </div>
          <div class="form-group row" formGroupName="jsonPaymentDetails">
            <label class="col-sm-4" translate>{{ 'partner_payout_form_bank_via_placeholder' }}</label>
            <div class="col-sm-8">
              <input
                type="text"
                name="via"
                formControlName="via"
                class="form-control"
                placeholder="{{ 'partner_payout_form_bank_via_placeholder' | translate }}"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Paypal -->
      <div *ngIf="getChosenPaymentMethod() === 'paypal'">
        <h5 class="my-5" translate>{{ 'partner_payout_form_paypal' }}</h5>
        <div class="page__form-wrap">
          <div class="form-group row" formGroupName="jsonPaymentDetails">
            <label class="col-sm-4" translate>{{ 'partner_payout_form_paypal' }}</label>
            <div class="col-sm-8">
              <input
                type="text"
                name="email"
                formControlName="email"
                class="form-control"
                placeholder="{{ 'partner_payout_form_paypal_placeholder' | translate }}"
                wsbAppControlValidator
                [fc]="payoutForm.get('jsonPaymentDetails.email')"
              />
              <wsb-validation-error-msg [fc]="payoutForm.get('jsonPaymentDetails.email')"></wsb-validation-error-msg>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
    <wsb-atlas-button
      variant="primary"
      [disabled]="payoutForm.pristine || payoutForm.invalid"
      (btnClick)="send.emit(btnSend())"
      [label]="labelSendButton"
    ></wsb-atlas-button>
  </div>
</div>
